import { ServiceReportsResponse } from "../../src/components/service-reports/service-reports-response";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const response: ServiceReportsResponse = {
    serviceReports: [
        {
            date: "2019-01-01 12:22:00",
            equipmentName: "TruBend 7000",
            equipmentNumber: "123456",
            technicianName: "John Doe",
            reportDownload: "#pdf",
            equipmentAlias: "Rambo",
        }
    ]
};

const writeToFile = (object: ServiceReportsResponse, name: string) => {
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

const response2 = {
    serviceReports: [
        ...response.serviceReports,
        {
            ...response.serviceReports[0],
            date: "2020-09-22 03:33:00",
            technicianName: "Benjamin Franklin",
        },
    ],
};

const responseEmpty: ServiceReportsResponse = {
    serviceReports: [],
};

writeToFile(response, "service-reports");
writeToFile(response2, "service-reports-multiple");
writeToFile(responseEmpty, "service-reports-empty");
